import React from 'react';
import Footer from '../../Components/Footers/Footer';
import Header from '../../Components/Headers/Header';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import '../../assests/css/SightSeeing.css';
import seight_seeing from '../../assests/images/seightseeing.png';
import img_car_mer from '../../assests/images/car.png';
import singlesight_road from '../../assests/images/singlesight-road.png';

const SingleSight = () => {

    return (
        <div className='singlesight'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Sight Seeing</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='mb-5'>
                <div className='container my-5 py-5'>
                    <div className='row'>
                        <div className='col-lg-7 mb-5'>
                            {/* <img src={singlesight_road} className="singlesight_img" /> */}
                            <div className='bg-img-singlesight'>

                            </div>
                        </div>
                        <div className='col-lg-5 mb-5'>
                            <div className='card'>
                                <div className='card-body p-res-singlesight-mob p-5 pb-1'>
                                    <p className='f-22 f-pop-semibold'>Your Route</p>
                                    <ul className="ul_pad_zero  mt-4">
                                        <li className="ul_tick_round f-pop-med clr-9f f-14">
                                            Lorem ipsum
                                        </li>
                                        <li className="ul_tick_round f-pop-med clr-9f f-14">
                                            Lorem ipsum
                                        </li>
                                        <li className="ul_tick_round f-pop-med clr-9f f-14">
                                            Lorem ipsum
                                        </li>
                                        <li className="ul_tick_round f-pop-med clr-9f f-14">
                                            Lorem ipsum
                                        </li>
                                    </ul>
                                    <div className='singlesight_border-btm mb-4 mt-3'>

                                    </div>
                                    <p className='f-16 f-pop-semibold mb-2'>Pickup Address</p>
                                    <p className='clr-62 f-pop-reg f-16'>
                                        Lorem Ipsum is simply dummy text of the printing and
                                        typesetting industry
                                    </p>
                                    <div className='singlesight_border-btm  mb-4 mt-4'>

                                    </div>
                                    <p className='f-16 f-pop-semibold'>Drop Off Address</p>
                                    <p className='clr-62 f-pop-reg f-16 mt-2'>
                                        Lorem Ipsum is simply dummy text of the printing and
                                        typesetting industry
                                    </p>
                                    <div className='singlesight_border-btm  mb-4 mt-4'>

                                    </div>

                                    <div className='row'>
                                        <div className='col-lg-7'>
                                            <p className='f-16 f-pop-semibold'>Vehicle</p>
                                            <p className='clr-62 f-pop-reg f-16 mt-2'>
                                                Lorem Ipsum is simply dummy
                                                text of the printing.
                                            </p>
                                        </div>
                                        <div className='col-lg-5'>
                                            <img src={img_car_mer} className='van_mercedes_single' alt="mercedes van" />
                                        </div>
                                    </div>
                                    <div className='singlesight_border-btm  mb-4 mt-4'>

                                    </div>
                                    <div className='row'>
                                        <div className='col-lg-6'>
                                            <p className='f-16 f-pop-semibold'>Passanger Capacity :</p>
                                        </div>
                                        <div className='col-lg-6 text-end'>
                                            <p className='clr-62 f-pop-reg f-16'>8 perosns</p>
                                        </div>
                                    </div>
                                    <div className='singlesight_border-btm  mb-4 mt-4'>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg_red_singleSight mt-5 ">
                <div className="container ">
                    <div className="row ">
                        <div className="col-lg-6 py-5 align-self-center">
                            <p className='f-20 f-pop-med text-white'>
                                24x7
                            </p>
                            <p className="f-45 f-pop-semibold text-white lh-01">
                                We Are Ready To Take Your Call
                            </p>
                            <p className="f-60 f-pop-med text-white">
                                +441279-247-247
                            </p>
                        </div>
                        <div className="col-lg-6 ">

                            {/* <button className="btn btn-danger f-14 bt-aboutus clr-white-btn-book f-pop-med mt-3 mb-5">
                                Book now
                            </button> */}
                            <div className='pos-rel h-100-w-100'>
                                <div className="bg-van-btm">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    )
}

export default SingleSight;